import { useContext } from 'react';
import AuthenticationContext from '../contexts/AuthenticationContext';
function useAuthentication() {
  return useContext(AuthenticationContext);
}
export default useAuthentication;